import React from 'react';
import PropTypes from 'prop-types';

import AbstractFunnel from "@components/abstract_funnel";
import withLoader from '@components/common/with_loader_decorator';
import withHistory from '@components/common/with_history_decorator'
import withPhoneCollector from '@components/common/with_phone_collector_decorator'
import Authenticator from '@components/common/authenticator'

import FunnelStatePersistance from '@services/funnel_state_persistance'

class BathroomCleaningFunnel extends AbstractFunnel {
    static childContextTypes = {
        locationStrategy: PropTypes.string
    };

    componentDidMount() {
        if(this.props.initializeStateAndHistory){
            this.props.initializeStateAndHistory({ componentName: 'BathroomCleaningFunnel', currentState: this.state });
        }

        FunnelStatePersistance.loadPersistedStateIfNeeded(this);
    }

    serviceType = () => {
        return 'bathroom_cleaning';
    };

    availabilityPathString = () => {
        return 'bathroom_cleaning_availability_path';
    };

    companiesForDatePath = () => {
        return PathHelper('companies_for_date_bathroom_cleaning_requests_path');
    };

    attributesPath = () => {
        return PathHelper('attributes_bathroom_cleaning_requests_path');
    };

    extraServiceTypes = () => {
        return ['carpet_and_upholstery_cleaning', 'oven_cleaning']
    };
}


BathroomCleaningFunnel = withLoader(BathroomCleaningFunnel);
BathroomCleaningFunnel = withPhoneCollector(BathroomCleaningFunnel);
BathroomCleaningFunnel = withHistory(BathroomCleaningFunnel);

class AuthenticatingBathroomCleaningFunnel extends React.Component {
    render() {
        return (
            <Authenticator status={this.props.componentProps.authenticationStatus}
                           omniauthError={this.props.componentProps.omniauthError}
                           component={BathroomCleaningFunnel}
                           {...this.props} />
        );
    }
}

export default AuthenticatingBathroomCleaningFunnel;
